
/*****************************************
 Vue-Router.js Vue路由
 控制页面的局部跳转刷新
 *****************************************/

import Vue from 'vue'                   // 引入Vue
import Router from 'vue-router'         // 引入vue-router
import Login from './views/Login.vue'   // 引入views目录下的Login.vue组件
import Home from './views/Home.vue'     // 引入views目录下的Home.vue组件
import FriendChat from './views/chat/FriendChat.vue' // 引入views目录下的FriendChat.vue组件
import HrInfo from './views/HrInfo.vue' // 引入views目录下的HrInfo.vue组件

// 启用路由 Vue全局使用Router
Vue.use(Router)

// 定义路由


export default new Router({
//    mode: 'history',    // 去除# https://www.cnblogs.com/zhuzhenwei918/p/6892066.html
    routes: [                   // 配置路由数组
        { // 每一个链接都是一个对象
            path: '/',          // 链接路径
            name: 'Login',      // 路由名称
            component: Login,   // 对应的组件
            hidden:true         //
        },
        { // 每一个链接都是一个对象
            path: '/home',
            name: 'Home',
            component: Home,
            hidden:true,
            meta:
            {
                roles:['admin','user']
            },
            children:[ // 子路由,嵌套路由
                {
                    path: '/chat',
                    name: '在线聊天',
                    component: FriendChat,
                    hidden:true
                },{
                    path: '/hrinfo',
                    name: '个人中心',
                    component: HrInfo,
                    hidden:true
                }
            ]
        }
    ]
})